export default __webpack_public_path__ + "static/media/IMG-20240822-WA0011.9ebc4906.jpg";